import React from 'react';

import Skeleton from 'coreComponents/Skeleton';

import Grid from 'brandComponents/Grid';

import styles from './SkeletonPDP.module.scss';

const SkeletonPDP = () => (
	<div>
		<Grid fluid>
			<Grid.Row>
				<Grid.Column lg={9} classNames={styles['product-detail__img-wrapper']}>
					<Skeleton classNames={styles['product-detail__img']} height="auto" width="50%" />
					<Skeleton classNames={styles['product-detail__img']} height="auto" width="50%" />
					<Skeleton classNames={styles['product-detail__img']} height="auto" width="50%" />
					<Skeleton classNames={styles['product-detail__img']} height="auto" width="50%" />
				</Grid.Column>
				<Grid.Column lg={3} classNames={styles['product-detail__description__wrapper']}>
					<div className={styles['product-detail__description']}>
						<Skeleton height="460px" width="100%" />
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row classNames={styles['product-detail__bottom']}>
				<Grid.Column>
					<Skeleton height="390px" width="100%" />
				</Grid.Column>
			</Grid.Row>
		</Grid>
	</div>
);

export default SkeletonPDP;
